import { Box } from '@mui/system';
import React from 'react'
import Header from '../../components/global/Header';
import Barchart from '../../components/scenes/Barchart';


function ManageUsers() {
  return(
    <>
       <Box m="20px" >
       <Header title='Manage users dashboard' subtitle={'Hello Admin manage all the users'} />
       </Box>
    </>
  )
}

export default ManageUsers;